export default __webpack_public_path__ + "static/media/inventory-icon-new.11c977c5.svg";